import { measureLatency } from '../../gctl-measure';
import { NetworkError, deepCamelCase } from '../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetMeGroupFields = readonly string[];

/** Options for GET /me/groups/{group_id} */
export type GetMeGroupOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the group.
     */
    groupId: number;
  };
};

/** Result type for GET /me/groups/{group_id} */
export type GetMeGroupResult<Paths extends readonly string[]> = unknown;

/**
 * Check if a user has joined a group
 * This method determines whether the authenticated user belongs to the specified group.
 */
export async function getMeGroup<Paths extends GetMeGroupFields>({
  baseUrl,
  where: { groupId },
  ...options
}: GetMeGroupOptions<Paths>): Promise<GetMeGroupResult<Paths>> {
  return measureLatency('getMeGroup', 'GET', async () => {
    let res = await fetch(`${baseUrl}/me/groups/${groupId}`, {
      ...options,
      method: 'GET',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as GetMeGroupResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}

export type PutMeGroupFields = readonly string[];

/** Options for PUT /me/groups/{group_id} */
export type PutMeGroupOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the group.
     */
    groupId: number;
  };
};

/** Result type for PUT /me/groups/{group_id} */
export type PutMeGroupResult<Paths extends readonly string[]> = unknown;

/**
 * Add the user to a group
 * This method adds the authenticated user to the specified group.
 */
export async function putMeGroup<Paths extends PutMeGroupFields>({
  baseUrl,
  where: { groupId },
  ...options
}: PutMeGroupOptions<Paths>): Promise<PutMeGroupResult<Paths>> {
  return measureLatency('putMeGroup', 'PUT', async () => {
    let res = await fetch(`${baseUrl}/me/groups/${groupId}`, {
      ...options,
      method: 'PUT',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as PutMeGroupResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}

export type DeleteMeGroupFields = readonly string[];

/** Options for DELETE /me/groups/{group_id} */
export type DeleteMeGroupOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the group.
     */
    groupId: number;
  };
};

/** Result type for DELETE /me/groups/{group_id} */
export type DeleteMeGroupResult<Paths extends readonly string[]> = unknown;

/**
 * Remove the user from a group
 * This method removes the authenticated user from the specified group. The authenticated user can't be the owner of the group; assign a new owner through a PATCH request first.
 */
export async function deleteMeGroup<Paths extends DeleteMeGroupFields>({
  baseUrl,
  where: { groupId },
  ...options
}: DeleteMeGroupOptions<Paths>): Promise<DeleteMeGroupResult<Paths>> {
  return measureLatency('deleteMeGroup', 'DELETE', async () => {
    let res = await fetch(`${baseUrl}/me/groups/${groupId}`, {
      ...options,
      method: 'DELETE',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as DeleteMeGroupResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
